import React, { useEffect, useMemo, useState } from "react";
import WeekItem from "./WeekItem";
import "../../../../../../styles/ambassadorChallenge/wallOfFame.scss";
import axios from "axios";
import { isAuth } from "../../../../../../pages/auth/ProtectedRoute";

const PAGE_SIZE = 4;

const WallOfFame: React.FC = () => {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);

   const [weekData, setWeekData] = useState<WeekData[] | null>(null);
 
  useEffect(() => {
    const fetchPrizes = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_HOST_API}ambassador/wall-of-fame`,
          {
            headers: {
              Authorization: `Bearer ${isAuth()}`,
            },
          }
        );
        setWeekData(res.data.data.data);
      } catch (err: any) {
        console.log("error fetching prizes data:", err);
      }
    };

    fetchPrizes();
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return weekData;
    return weekData && weekData.filter(
      (w) =>
        w.title.toLowerCase().includes(q) ||
        w.winners.some((x) => x.referrer_name.toLowerCase().includes(q))
    );
  }, [query, weekData]);

  const pageCount = filtered ? Math.max(1, Math.ceil(filtered.length / PAGE_SIZE)) : 0;
  const pageData = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return filtered && filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, page]);

  // reset page when query changes
  useEffect(() => setPage(1), [query]);


  return (
    <section className="wof-card">
      <header className="wof-header">
        <div>
          <h3>Wall of Fame</h3>
          <p className="subtitle">View previous challenge winners and their achievements</p>
        </div>

        <div className="wof-search">
          <svg className="icon-search" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="6" stroke="#c6c6c6" strokeWidth="1.5" />
            <path d="M21 21l-4.35-4.35" stroke="#c6c6c6" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <input
            placeholder="Search by user's name or challenge title"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </header>

      <div className="wof-list">
        {pageData && pageData.map((w) => (
          <WeekItem key={w.challenge_id} {...w} />
        ))}
      </div>

      <footer className="wof-footer">
        <div className="page-info">Page {page} of {pageCount}</div>

        <div className="pagination">
          <button className="page-btn" onClick={() => setPage((s) => Math.max(1, s - 1))} disabled={page <= 1}>
            Previous
          </button>
          <button className="page-btn" onClick={() => setPage((s) => Math.min(pageCount, s + 1))} disabled={page >= pageCount}>
            Next
          </button>
        </div>
      </footer>
    </section>
  );
};

export default WallOfFame;
